import tagsService from "api/tagsService";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import PersonsIcon from "assets/icons/groups.svg?react";
import { useContext, useMemo, useRef, useState } from "react";
import { ITag } from "dto/ITag";
import Chip from "components/Chip";
import CasePerson from "components/CaseParticipantsModal";
import CasesContext from "contexts/CasesContext";
import { cleanSearchHighlight } from "utils/cleanSearchHighlight";

const CaseLeftSideHeader: FC<Props> = ({ Case }) => {
  const { cases } = useContext(CasesContext);
  const { data: tagsData } = tagsService.useGetTags();
  const tagsList: ITag[] = useMemo(
    () => (tagsData?.data as ITag[]) ?? [],
    [tagsData]
  );

  const findedTags = useMemo(
    () =>
      tagsList?.filter(
        (tag: ITag) =>
          cases
            .find((c) => c.Id === Case?.Id)
            ?.TagIds?.find((iTag) => tag.Id === iTag) ??
          Case?.TagIds?.find((iTag) => tag.Id === iTag)
      ) ?? [],
    [tagsList, Case.TagIds, Case, cases]
  );

  const personWrapper = useRef<HTMLDivElement>();

  const [showPerson, setShowPerson] = useState(false);

  return (
    <div className={styles.wrapper}>
      <div ref={personWrapper}>
        <div
          onClick={() => setShowPerson(!showPerson)}
          className={styles.persons}
        >
          <PersonsIcon className={styles.personIcon} />
        </div>
        {showPerson && (
          <div className={styles.modal}>
            <div className={styles.bg}></div>
            <div className={styles.modalCenter}>
              <CasePerson Case={Case} toggle={() => setShowPerson(false)} />
            </div>
          </div>
        )}
      </div>
      <div className={styles.information}>
        <div className={styles.top}>
          <div title={Case.Title} className={styles.title}>
            {cleanSearchHighlight(Case?.Title)}
          </div>
          <div className={styles.tags}>
            {findedTags.map((tag) => (
              <Chip key={tag.Id} small element={<>{tag.Name}</>} />
            ))}
          </div>
        </div>
        <div className={styles.bottom}>
          {Case?.Client && cleanSearchHighlight(Case.Client)}
        </div>
      </div>
    </div>
  );
};

export default CaseLeftSideHeader;
